module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h2', {
    staticClass: "h2v"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("LIST OF TEXTUAL ABBREVIATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following is a list of the abbreviations used within the present work when referring to Plato's texts. Note that if a Stephanus number is cited "), _c('em', [_vm._v("without")]), _vm._v(" being preceded by one of the following abbreviations, the citation is from the "), _c('em', [_vm._v("Cratylus.")])]), _vm._v(" "), _c('table', {
    staticClass: "abb",
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', [_vm._v("Ap.")]), _vm._v(" "), _c('td', [_vm._v("(Apology)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Epist.")]), _vm._v(" "), _c('td', [_vm._v("(Letters)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Euthd.")]), _vm._v(" "), _c('td', [_vm._v("(Euthydemus)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Euthr.")]), _vm._v(" "), _c('td', [_vm._v("(Euthyphro)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hipp.")]), _vm._v(" "), _c('td', [_vm._v("(Hipparchus)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Lg.")]), _vm._v(" "), _c('td', [_vm._v("(Laws)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Phd.")]), _vm._v(" "), _c('td', [_vm._v("(Phaedo)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Phdr.")]), _vm._v(" "), _c('td', [_vm._v("(Phaedrus)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Phil.")]), _vm._v(" "), _c('td', [_vm._v("(Philebus)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Prot.")]), _vm._v(" "), _c('td', [_vm._v("(Protagoras)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Rep.")]), _vm._v(" "), _c('td', [_vm._v("(Republic)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Stat.")]), _vm._v(" "), _c('td', [_vm._v("(Statesman)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Symp.")]), _vm._v(" "), _c('td', [_vm._v("(Symposium)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tht.")]), _vm._v(" "), _c('td', [_vm._v("(Theaetetus)"), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0d204c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Abbrivations.vue
// module id = 87
// module chunks = 0